import Vue from 'vue'
import Vuex from 'vuex'
import { api } from '@/api/api';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    customerUrl: null,
    customerPhone: null,
    sysDictDataList: [],
  },
  
  getters: {
    customerUrl: state => state.customerUrl,
    customerPhone: state => state.customerPhone,
    sysDictDataList: state => state.sysDictDataList,
  },
  
  mutations: {
     SET_CUSTOMER_INFO(state, data) {
      state.customerUrl = data.serviceUrl || null
      state.customerPhone = data.servicePhone || null
      state.sysDictDataList = data.sysDictDataList || []
      // console.log("response.data1", data);
    }
  },
  actions: {
    async fetchCustomerInfo({ commit }) {
      try {
         const response = await api.get('baoyan/customerService/getByServiceType/0', null, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        if (response && response.code === 200 && response.data && response.data.status === 0) {
          commit('SET_CUSTOMER_INFO', response.data)
        }        
      } catch (error) {
        console.error('获取客服信息失败:', error)
      }
    }
  },
  
  modules: {
  }
})